var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoboticArm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 159.37,
    y1: 34.72,
    x2: 116.4,
    y2: 59.63
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 100.81,
    y1: 94.43,
    x2: 100.81,
    y2: 128.46
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M107,73.28a5.39,5.39,0,1,1-5.38-5.45A5.42,5.42,0,0,1,107,73.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M121.12,73.21a19.66,19.66,0,1,1-19.66-19.84A19.75,19.75,0,0,1,121.12,73.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M92.65,162.15h17l.58,30.89m0,0a32.18,32.18,0,1,0-17.62-.27V162.15h17.78Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoboticArm);
export default __webpack_public_path__ + "static/media/ROBOTIC_ARM.1b44bcd76e2f5da704da9f608577abfb.svg";
export { ForwardRef as ReactComponent };